import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Checkout cancelled</h2>
        <p style={styles.text}>No charge was made. You can try again anytime from your dashboard.</p>
        <button onClick={() => navigate('/dashboard')} style={styles.button}>Back to Dashboard</button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    textAlign: 'center',
    maxWidth: '420px',
  },
  title: { color: '#333', marginBottom: '10px' },
  text: { color: '#666', marginBottom: '20px' },
  button: {
    padding: '12px 24px',
    backgroundColor: '#e67e22',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default PaymentCancel;
